import service from '@/utils/server';

const modName='/finance/invoice/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};
//详情
export const queryBillDetail = data => {
  return service({
    url: modName + 'billDetail/' + data,
    method: 'post',
    data
  });
};

//修改
export const submitData = data => {
  return service({
    url: modName + 'uptConfirm/' + data,
    method: 'post',
    data
  });
};

//导出文件方法
export const getExportData = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

export const billDetailExport = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'billDetailExport/' + data,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/finance/invoice/api/index.js